import {Event} from "../../../../common/event/Event"

export enum GridPresetsEventType {
    PRESETS_RESET = "PRESETS_RESET",
}

export interface GridPresetsResetEvent extends Event {
    type: GridPresetsEventType.PRESETS_RESET;
}